module.exports = __webpack_public_path__ + "img/pdf_preview_singleuse_de.12f138fc.png";